import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    submenu?: RouteInfo[];
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: 'administracion', title: 'Administración',  icon:'assignment', class: '', submenu:[
        { path: '/datos/ejecuciones', title: 'Ejecuciones',  icon: 'E', class: '' },
        { path: '/datos/binarios', title: 'Binarios',  icon: 'B', class: '' },
        { path: '/datos/reportes_de_cedis', title: 'Cedis',  icon: 'C', class: '' },
      ]
    },
    { path: 'datos', title: 'Datos',  icon:'folder', class: '', submenu:[
      { path: '/datos/categorias', title: 'Conceptos',  icon: 'C', class: '' },
      { path: '/datos/evaluaciones', title: 'Evaluaciones',  icon: 'E', class: '' },
      { path: '/datos/cedis', title: 'CEDIS',  icon: 'C', class: '' },
      { path: '/datos/oficinas_de_ventas', title: 'Oficinas de ventas',  icon: 'O', class: '' },
      // { path: '/datos/area_de_ventas', title: 'Areas de ventas',  icon: 'A', class: '' },
      { path: '/datos/almacenistas', title: 'Almacenistas',  icon: 'P', class: '' },
      // { path: '/datos/clientes', title: 'Clientes',  icon: 'C', class: '' },
      { path: '/datos/evaluadores', title: 'Evaluador',  icon: 'E', class: '' },
    ]},
    // { path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
    // { path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
    // { path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
    // { path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
    // { path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
    // { path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
